import { get } from '@ember/object';

export default function validateUniqueUserEmail({ allUsers } = {}) {
  let usersByEmail = {};
  allUsers.forEach((user) => {
    usersByEmail[get(user, 'emailLowerCase')] = user;
  });
  return (key, newValue, oldValue, changes, content) => {
    if (newValue === oldValue) {
      return true;
    }
    let userWithSameEmail = usersByEmail[newValue.toLowerCase()];
    if (
      userWithSameEmail != null &&
      get(userWithSameEmail, 'id') !== get(content, 'id')
    ) {
      return `Another user (${get(userWithSameEmail, 'displayName')}) already has the same email address`;
    }
    return true;
  };
}
